export const SCOPE = 'default_landing_page';
export const INIT = `${SCOPE}/INIT`;
export const SET_DEFAULT_LANDING_PAGE = `${SCOPE}/SET_DEFAULT_LANDING_PAGE`;
export const GET_DEFAULT_LANDING_PAGE = `${SCOPE}/GET_DEFAULT_LANDING_PAGE`;
export const UPDATE_DEFAULT_LANDING_PAGE = `${SCOPE}/UPDATE_DEFAULT_LANDING_PAGE`;
export const GET_DEFAULT_LANDING_PAGE_SUCCESS = `${SCOPE}/GET_DEFAULT_LANDING_PAGE_SUCCESS`;
export const SHOW_PROMPT = `${SCOPE}/SHOW_PROMPT`;
export const HIDE_PROMPT = `${SCOPE}/HIDE_PROMPT`;
export const SET_PROMPT_TITLE = `${SCOPE}/SET_PROMPT_TITLE`;
export const SET_PROMPT_CONTENT = `${SCOPE}/SET_PROMPT_CONTENT`;
export const SET_PROMPT_NEED_INPUT = `${SCOPE}/SET_PROMPT_NEED_INPUT`;
export const SET_PROMPT_OK_FN = `${SCOPE}/SET_PROMPT_OK_FN`;
export const SET_TMP_PAYLOAD = `${SCOPE}/SET_TMP_PAYLOAD`;
export const SET_CUSTOMER_ID = `${SCOPE}/SET_CUSTOMER_ID`;
